export default __webpack_public_path__ + "static/media/position_fixed.c34f6b28.gif";